import React, { useState } from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '971567953704';

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Popup Window */}
      {isOpen && (
        <div className="whatsapp-popup">
          <button className="whatsapp-close" onClick={togglePopup}>
            ✕
          </button>
          
          <div className="whatsapp-popup-header">
            <h3>تواصل معنا مباشرة</h3>
            <p>ابق على تواصل معنا، سنرد قصارى جهدنا لاستعدادك</p>
          </div>

          <button className="whatsapp-popup-button" onClick={handleWhatsAppClick}>
            <span className="whatsapp-icon-popup">
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M16 0C7.163 0 0 7.163 0 16c0 2.831.74 5.49 2.039 7.794L0 32l8.378-2.007A15.896 15.896 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.257c-2.55 0-4.95-.725-6.984-1.98l-.502-.298-4.888 1.171 1.186-4.762-.332-.524A13.195 13.195 0 0 1 2.743 16c0-7.304 5.953-13.257 13.257-13.257S29.257 8.696 29.257 16 23.304 29.257 16 29.257z"/>
                <path fill="currentColor" d="M23.363 19.594c-.402-.201-2.377-1.173-2.745-1.306-.368-.134-.635-.201-.902.2-.268.402-1.035 1.306-1.269 1.574-.234.267-.469.301-.87.1-.402-.2-1.695-.625-3.228-1.993-1.193-1.065-1.999-2.38-2.233-2.782-.234-.401-.025-.618.176-.818.18-.18.402-.469.603-.703.201-.234.268-.401.402-.669.134-.267.067-.502-.033-.703-.1-.2-.902-2.175-1.236-2.978-.325-.782-.655-.676-.902-.688-.234-.012-.502-.015-.77-.015s-.703.1-1.071.502c-.368.401-1.403 1.373-1.403 3.348s1.437 3.883 1.637 4.151c.201.267 2.831 4.324 6.857 6.064.958.413 1.706.66 2.289.845.962.305 1.837.262 2.528.159.771-.115 2.377-.972 2.711-1.91.335-.938.335-1.742.234-1.91-.1-.168-.368-.268-.77-.469z"/>
              </svg>
            </span>
            <div className="whatsapp-popup-text">
              <span className="whatsapp-label">مركز آفاق</span>
              <span className="whatsapp-subtitle">AafaqCentre</span>
            </div>
            <span className="whatsapp-icon-small">
              <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M16 0C7.163 0 0 7.163 0 16c0 2.831.74 5.49 2.039 7.794L0 32l8.378-2.007A15.896 15.896 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.257c-2.55 0-4.95-.725-6.984-1.98l-.502-.298-4.888 1.171 1.186-4.762-.332-.524A13.195 13.195 0 0 1 2.743 16c0-7.304 5.953-13.257 13.257-13.257S29.257 8.696 29.257 16 23.304 29.257 16 29.257z"/>
                <path fill="currentColor" d="M23.363 19.594c-.402-.201-2.377-1.173-2.745-1.306-.368-.134-.635-.201-.902.2-.268.402-1.035 1.306-1.269 1.574-.234.267-.469.301-.87.1-.402-.2-1.695-.625-3.228-1.993-1.193-1.065-1.999-2.38-2.233-2.782-.234-.401-.025-.618.176-.818.18-.18.402-.469.603-.703.201-.234.268-.401.402-.669.134-.267.067-.502-.033-.703-.1-.2-.902-2.175-1.236-2.978-.325-.782-.655-.676-.902-.688-.234-.012-.502-.015-.77-.015s-.703.1-1.071.502c-.368.401-1.403 1.373-1.403 3.348s1.437 3.883 1.637 4.151c.201.267 2.831 4.324 6.857 6.064.958.413 1.706.66 2.289.845.962.305 1.837.262 2.528.159.771-.115 2.377-.972 2.711-1.91.335-.938.335-1.742.234-1.91-.1-.168-.368-.268-.77-.469z"/>
              </svg>
            </span>
          </button>

          <div className="whatsapp-popup-footer">
            <span className="whatsapp-loading-icon">⟳</span>
            <p>آفــاق - بداد إعداد جيل المستقبل</p>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button 
        className="whatsapp-float-button"
        onClick={togglePopup}
        aria-label="تواصل عبر واتساب"
      >
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M16 0C7.163 0 0 7.163 0 16c0 2.831.74 5.49 2.039 7.794L0 32l8.378-2.007A15.896 15.896 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.257c-2.55 0-4.95-.725-6.984-1.98l-.502-.298-4.888 1.171 1.186-4.762-.332-.524A13.195 13.195 0 0 1 2.743 16c0-7.304 5.953-13.257 13.257-13.257S29.257 8.696 29.257 16 23.304 29.257 16 29.257z"/>
          <path fill="currentColor" d="M23.363 19.594c-.402-.201-2.377-1.173-2.745-1.306-.368-.134-.635-.201-.902.2-.268.402-1.035 1.306-1.269 1.574-.234.267-.469.301-.87.1-.402-.2-1.695-.625-3.228-1.993-1.193-1.065-1.999-2.38-2.233-2.782-.234-.401-.025-.618.176-.818.18-.18.402-.469.603-.703.201-.234.268-.401.402-.669.134-.267.067-.502-.033-.703-.1-.2-.902-2.175-1.236-2.978-.325-.782-.655-.676-.902-.688-.234-.012-.502-.015-.77-.015s-.703.1-1.071.502c-.368.401-1.403 1.373-1.403 3.348s1.437 3.883 1.637 4.151c.201.267 2.831 4.324 6.857 6.064.958.413 1.706.66 2.289.845.962.305 1.837.262 2.528.159.771-.115 2.377-.972 2.711-1.91.335-.938.335-1.742.234-1.91-.1-.168-.368-.268-.77-.469z"/>
        </svg>
      </button>
    </>
  );
}

export default WhatsAppButton;
